<hsg-modal>
  <span class="title">סיום</span>
  <div [gaManager]="{type:'impression',category:this.gaCategory,action:'Successful Registration',label:'Successful Registration'}"
    class="body">
    <p>
      השלמת את תהליך הזיהוי והעדכון בהצלחה
    </p>
    <p>
      בכל כניסה עתידית למידע האישי שלך תקבל סיסמה חד פעמית לטלפון הנייד.
    </p>
  </div>
  <div class="actions">
    <button hsg-button kind="primary" (click)="submit()">למידע האישי
    </button>
  </div>
</hsg-modal>